"use client";
import animationData from "./cxm-first-animation.json";
import Lottie from "react-lottie";

/** @param {Partial<import("react-lottie").LottieProps>} props */
export default function CxmFirstLottie(props) {
  return (
    <Lottie
      {...props}
      options={{
        loop: true,
        autoplay: true,
        rendererSettings: { preserveAspectRatio: "xMidYMid slice" },
        ...props.options,
        animationData,
      }}
    />
  );
}
